import React from 'react';

import { Select } from '@/components/ui/catalyst/select';
import { Text } from '@/components/ui/catalyst/text';
import { TreatmentRecordRequestStatus } from '@/services/api/generated/treatmentRecordRequestsService';

import { VOICE_AI_INTERVAL_OPTIONS } from '../../../constants';

interface VoiceAIIntervalSelectorProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  showHelperText?: boolean;
  status?: TreatmentRecordRequestStatus;
}

export const VoiceAIIntervalSelector: React.FC<
  VoiceAIIntervalSelectorProps
> = ({ value, onChange, disabled = false, showHelperText = true, status }) => {
  const select = (
    <Select
      value={value.toString()}
      onChange={(e) => onChange(parseInt(e.target.value, 10))}
      disabled={disabled}
      className="w-48"
    >
      {VOICE_AI_INTERVAL_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  );

  if (!showHelperText) {
    return select;
  }

  return (
    <div className="flex flex-col gap-2">
      {select}
      <Text className="text-xs text-gray-500">
        {status === 'pending'
          ? 'Will apply after submission. Default: Every 3 days'
          : 'Changes apply to calls after the next scheduled one'}
      </Text>
    </div>
  );
};
